import script from "./LayoutDefaultComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayoutDefaultComponent.vue?vue&type=script&lang=ts&setup=true"

import "./LayoutDefaultComponent.vue?vue&type=style&index=0&id=4b6e723d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6e723d"]])

export default __exports__